import React, { useState, useEffect } from "react";
import { useParams,useNavigate,Link } from 'react-router-dom';
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import { escapeHtml,unescapeHtml,ChangeDateStringOnlyDate,ChangeSearchingDateFormat } from "../../../components/common/Common";

//게시판 정보 편집
function FaqDetail() {
  const admin_idx = Number(localStorage.getItem('adminIdx'));
  let { board_idx } = useParams();
  const navigator = useNavigate();

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);


  //게시판 변수 저장 객체
  const newData = {      
    board_idx: 0,
    mem_idx: admin_idx,
    mem_name:"관리자",
    board_type: 0,
    board_title: "",
    board_comment: "",
    board_rdate: ChangeSearchingDateFormat(new Date(),'.'),
    board_hits: 0,
    board_status:1
  };

  //게시판정보
  const [varFaqInfo,setFaqInfo] = useState({});
  //분류목록
  const [varFaqTypeList,setFaqTypeList] = useState([]);

  //게시판정보 읽어오기
  const getFaqInformation = async () => {
    var sendData = {mode:2,board_idx: board_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_board_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0) {
          setFaqInfo(datas.results[0]);
        }
        setFaqTypeList(datas.faq_types);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'ENVIRONMENT',item:'FAQ'});
    console.log(varAdminMenus);
    setFaqInfo(newData);
    getFaqInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [board_idx]);

  //회원정보편집
  const onFaqInfoHandler = (e) => {
    const {name,value} = e.currentTarget;
    if(name === "board_comment") {
      setFaqInfo({...varFaqInfo, [name]:escapeHtml(value)});
    } else if(name === "board_type") {
      setFaqInfo({...varFaqInfo, [name]:Number(value)});
    } else {
      setFaqInfo({...varFaqInfo, [name]:value});
    }
  }

  //FAQ삭제---------
  const onDeleteFaqHandler = async(e) => {
    if (!window.confirm("선택된 FAQ 정보를 삭제합니까?")) return false;
    const boardIndexString = [varFaqInfo.board_idx];
    const sendData = {mode:2,delitems: boardIndexString};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_delete_board_list`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        navigator(`/Admin/FaqList`);
      } else {
        alert(res.data.message);
      }
    });  
  }
  //FAQ정보 서버에 등록---------
  //FAQ정보등록전에 첨부파일 저장
  const onUpdateFaqHandler = async (e) => {
    if(varFaqInfo.board_type === 0) {
      alert('분류를 먼저 선택하세요.'); return false;
    } else if(varFaqInfo.board_title === '') {
      alert('제목을 먼저 입력하세요.'); return false;
    } else if(varFaqInfo.board_comment === '') {
      alert('내용을 먼저 입력하세요.'); return false;
    } 

    let prompt = "현재 선택된 FAQ의 정보를 저장합니까?";
    if(varFaqInfo.board_idx === 0)  prompt = "입력하신 FAQ을 등록합니까?";
    if(!window.confirm(prompt)) return false;

    const sendData = {mode:2,boardInfo:varFaqInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_board_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigator(`/Admin/FaqList`);
      } else {
        alert(datas.message);
      }
    });
  }


  return (    
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={'FAQ상세'} varDirection={'설정'}/>
      <div className="admin-content">
        <div className="main-box">
          <table className="write">
            <colgroup>
              <col width="20%"></col>
              <col width="80%"></col>
            </colgroup>
            <thead></thead>
            <tbody>
              <tr>
                <th>등록일자</th>
                <td>{ChangeDateStringOnlyDate(varFaqInfo.board_rdate||"")}</td>
              </tr>
              <tr>
                <th>등록자</th>
                <td>{varFaqInfo.mem_name||""}</td>
              </tr>
              <tr>
                <th>분류</th>
                <td>
                  <select value={varFaqInfo.board_type} name="board_type" style={{width:"200px"}} onChange={(e)=>onFaqInfoHandler(e)}>
                    <option value={0}>분류선택</option>
                    {varFaqTypeList.map((types,i)=>(
                      <option key={'types_'+i} value={types.vf_idx}>{types.vf_name}</option>
                    ))}
                  </select>
                </td>
              </tr>
              <tr>
                <th>제목</th>
                <td><input type="text" name="board_title" value={unescapeHtml(varFaqInfo.board_title||"")} onChange={(e)=>onFaqInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>내용</th>
                <td><textarea name="board_comment" style={{maxWidth:"100%"}} value={unescapeHtml(varFaqInfo.board_comment||"")} onChange={(e)=>onFaqInfoHandler(e)}/></td>
              </tr>
            </tbody>
          </table>
          <div className="btn-center">
            <Link to={`/Admin/FaqList`} style={{width:"100px"}} className="btn line">목록</Link>
            <button className="btn-danger" style={{width:"100px"}} onClick={(e)=>onUpdateFaqHandler(e)}>저장</button>
            <button className="btn black" style={{width:"100px"}} onClick={(e)=>onDeleteFaqHandler(e)}>삭제</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqDetail;